(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
var acc = document.getElementsByClassName("accordion");
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

// Open first accordion by default
document.addEventListener("DOMContentLoaded", function() {
  var firstAcc = document.querySelector(".accordion");
  var firstPanel = firstAcc.nextElementSibling;
  if (firstAcc && firstPanel) {
    firstAcc.classList.add("active");
    firstPanel.style.maxHeight = firstPanel.scrollHeight + "px";
  }
});

  } catch(e) { console.error(e); }
})();
})();
